import { EntityInfoPanel } from '@aibees/elephant/components/entity-info-panel';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(EntityInfoPanel)``;
